var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5731 12.4273L13.2761 15.7204H9.7021L14.6195 10.8043C14.8324 10.5905 14.9519 10.3011 14.9519 9.99935C14.9519 9.69762 14.8324 9.40818 14.6195 9.19438L9.00037 3.5753L3.38129 9.19438C3.16839 9.40818 3.04886 9.69762 3.04886 9.99935C3.04886 10.3011 3.16839 10.5905 3.38129 10.8043L8.29733 15.7204H4.72073L1.42768 12.4273C0.784272 11.7834 0.422852 10.9103 0.422852 10C0.422852 9.0897 0.784272 8.21664 1.42768 7.57269L8.99907 0L16.5783 7.57922C17.219 8.22359 17.5782 9.09564 17.5772 10.0043C17.5763 10.9131 17.2152 11.7843 16.5731 12.4273Z",
    fill: "#2750FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6912 7.59127L6.59275 9.68972C6.42179 9.86068 6.42179 10.1379 6.59275 10.3088L8.6912 12.4073C8.86216 12.5782 9.13934 12.5782 9.31029 12.4073L11.4087 10.3088C11.5797 10.1379 11.5797 9.86068 11.4087 9.68972L9.3103 7.59127C9.13934 7.42031 8.86216 7.42031 8.6912 7.59127Z",
    fill: "#01D5E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5797 16.4208L11.8793 17.1199H6.11904L5.41992 16.4208H8.99653L8.99915 16.4234L9.00307 16.4208H12.5797Z",
    fill: "#01D5E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99634 16.4208H9.00344L8.99918 16.4236L8.99634 16.4208Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1814 17.8177L10.4823 18.5181H7.51723L6.81812 17.8177H11.1814Z",
    fill: "#01D5E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78451 19.2159L8.99915 20L8.21509 19.2159H9.78451Z",
    fill: "#01D5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small_logo.1d82fcc0469f23104be82a3ea4f3fd8b.svg";
export { ForwardRef as ReactComponent };